import { render, staticRenderFns } from "./RewardListHistoryNewLayout.vue?vue&type=template&id=5e928dfc&scoped=true"
import script from "./RewardListHistoryNewLayout.vue?vue&type=script&lang=js"
export * from "./RewardListHistoryNewLayout.vue?vue&type=script&lang=js"
import style0 from "./RewardListHistoryNewLayout.vue?vue&type=style&index=0&id=5e928dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e928dfc",
  null
  
)

export default component.exports